import * as React from 'react';

export const RoadIcon = () => (
  // eslint-disable-next-line react/forbid-elements
  <svg xmlns="http://www.w3.org/2000/svg" width="15" height="14" viewBox="0 0 15 14">
    <path
      fill="#C9C9C9"
      fillRule="evenodd"
      d="M7.758 0h1.939l.97 4.848H8.242L7.758 0zm-.97 0l-.485 4.848H3.879L4.849 0h1.939zM3.394 7.273h2.909l-.485 6.303H1.94l1.455-6.303zm7.758 0l1.454 6.303H8.727l-.485-6.303h2.91zM0 5.333h14.545v1.455h-.97v1.454h-1.454V6.788H2.424v1.454H.97V6.788H0V5.333z"
    />
  </svg>
);
